export const isMobileDevice = (): boolean => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i;
  const isMobileUA = mobileRegex.test(userAgent);

  const isMobileViewport = window.innerWidth < 768;

  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  return isMobileUA || (isMobileViewport && isTouchDevice);
};

export const isLowMemoryDevice = (): boolean => {
  if (typeof navigator === 'undefined') {
    return false;
  }

  const memory = (navigator as any).deviceMemory;
  if (memory !== undefined) {
    return memory < 4;
  }

  const cores = navigator.hardwareConcurrency;
  if (cores !== undefined) {
    return cores < 4;
  }

  return false;
};

export const isSlowNetworkConnection = (): boolean => {
  if (typeof navigator === 'undefined') {
    return false;
  }

  const connection = (navigator as any).connection || (navigator as any).mozConnection || (navigator as any).webkitConnection;

  if (!connection) {
    return false;
  }

  const effectiveType = connection.effectiveType;
  if (effectiveType === 'slow-2g' || effectiveType === '2g') {
    return true;
  }

  if (connection.downlink !== undefined && connection.downlink < 1) {
    return true;
  }

  return false;
};

export const getDeviceInfo = () => {
  return {
    isMobile: isMobileDevice(),
    isLowMemory: isLowMemoryDevice(),
    isSlowNetwork: isSlowNetworkConnection(),
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : 'unknown',
    viewport: typeof window !== 'undefined' ? `${window.innerWidth}x${window.innerHeight}` : 'unknown',
    memory: typeof navigator !== 'undefined' ? (navigator as any).deviceMemory : undefined,
    cores: typeof navigator !== 'undefined' ? navigator.hardwareConcurrency : undefined,
  };
};

export const shouldReduceAnimations = (): boolean => {
  if (isLowMemoryDevice()) {
    return true;
  }

  if (typeof window !== 'undefined') {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    return mediaQuery.matches;
  }

  return false;
};

export const getOptimalTimeout = (baseTimeout: number): number => {
  const isMobile = isMobileDevice();
  const isLowMemory = isLowMemoryDevice();
  const isSlowNetwork = isSlowNetworkConnection();

  let multiplier = 1;

  if (isMobile) multiplier *= 1.5;
  if (isLowMemory) multiplier *= 1.5;
  if (isSlowNetwork) multiplier *= 2;

  return Math.round(baseTimeout * multiplier);
};

export const logDeviceInfo = () => {
  const info = getDeviceInfo();
  console.log('[DeviceDetection] Device info:', info);
  return info;
};
